// Prefer controls coming from the DB/question payload.
// Fall back to questionnaire config (optional) if needed.

/**
 * Normalize a single control entry.
 * Controls may be stored as plain strings ("GV.OC") or as stringified JSON
 * objects ({"code":"NIST-CSF-GV.OC-01","csv_domain":"Governance","nist_function":"Govern"}).
 * Always return the plain code string.
 */
function normalizeControl(raw: unknown): string | null {
  if (typeof raw !== "string" || !raw) return null;
  const trimmed = raw.trim();
  if (trimmed.startsWith("{")) {
    try {
      const parsed = JSON.parse(trimmed);
      if (typeof parsed.code === "string") return parsed.code;
    } catch {
      // not valid JSON — return as-is
    }
  }
  return trimmed;
}

export function getQuestionControls(q: any): string[] {
  // First check if controls are directly available from the API response
  const raw = q?.controls ?? q?.meta?.controls ?? q?.config?.controls;
  if (!Array.isArray(raw) || raw.length === 0) return [];

  // Normalize each entry — parse JSON objects, extract code
  return raw
    .map(normalizeControl)
    .filter((c): c is string => c !== null && c.length > 0);
}